import { Server } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ServersIcon = createLucideIcon(Server);
